import { Experience } from "types/experience";
import { WebRule } from "types/web-rule";
import { AvailabilityState } from "utils/availability-utils";

class AvailableTimesSection {
    hidden: number;
    id: number;
    name: string;
    timeSets: WebRule[];
    description: string;
    image: string;
    sortOrder: number;
    availabilityState: AvailabilityState;

    constructor(values?: Partial<AvailableTimesSection>) {
        this.hidden = values?.hidden ?? 0;
        this.id = values?.id ?? 0;
        this.name = values?.name ?? "";
        this.timeSets = values?.timeSets?.map((rule) => new WebRule(rule)) ?? [];
        this.sortOrder = values?.sortOrder ?? 0;
        this.description = values?.description ?? "";
        this.image = values?.image ?? "";
        this.availabilityState = values?.availabilityState ?? AvailabilityState.Available;
    }

    clone(): AvailableTimesSection {
        return new AvailableTimesSection({
            ...this,
            timeSets: this.timeSets.map((rule) => rule.clone()),
        });
    }
}

class AvailableTimesUnit {
    id: number;
    name: string;
    timeZone: string;
    sections: AvailableTimesSection[];
    experiences: Experience[];

    constructor(values?: AvailableTimesUnit) {
        this.id = values?.id ?? 0;
        this.name = values?.name ?? "";
        this.timeZone = values?.timeZone ?? "";
        this.sections =
            values?.sections?.map((section) => new AvailableTimesSection(section)) ?? [];
        this.experiences =
            values?.experiences?.map((experience) => new Experience(experience)) ?? [];
    }

    clone(): AvailableTimesUnit {
        return new AvailableTimesUnit({
            ...this,
            sections: this.sections.map((section) => section.clone()),
            experiences: this.experiences.map((experience) => experience.clone()),
        });
    }
}

export { AvailableTimesSection, AvailableTimesUnit };
